
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'PHWHOFC',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/PHWHOFC.vue